import React, { useState } from "react";
import { formatDate, formatValidSelect } from "../../../helpers/FormatHelper";
import { getStyle } from "../../../styles/styles";
import DatePicker from "../../shared/DatePicker";
import NewEditableGrid from "../../shared/NewEditableGrid";
import ReconciliationBankNotesForm from "./ReconciliationBankNotesForm";
import ReconciliationBankNotesProvider from "./ReconciliationBankNotesProvider";
import { useContext } from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { deleteVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import { getBNVaultBalances } from "../../../networking/NetworkingOrders";

const style = getStyle();


const ReconciliationBankNotesScreenContent = () => {

    const {
        data,
        columnDetails,
        dateReported,
        setDateReported,
        page,
        setPage,
        vaultSelected,
        setVaultSelected,
        setVaultReconciliationRecord,
        loadVaultReconciliation,
        alreadyReconciliated,
        reload,
        alertMessage,
        setAlertMessage,
        confirmationMessage,
        setConfirmationMessage,
        isBankNotesAdmin,        
        setLoading,
        currencyDenominations,
        defaultReconciliation,
        vaultBalances,
        setVaultBalances
    } = useContext(ReconciliationBankNotesContext);

    const vaultOptions = [
        { value: "-1", name: "Select a vault ..." },
        { value: "1", name: "Main office" },
    ];
    const [validations, setValidations] = useState({
        vault: true,
    });

    const validateForm = () => {
        let newValidations = { ...validations };
        if (Number(vaultSelected.id) > 0) {
            newValidations.vault = true;
        } else {
            newValidations.vault = false;
        }
        setValidations(newValidations);
        return newValidations.vault;
    };

    const addNewReconciliation = async () => {
        if (validateForm()) {
            const reconciliationId = alreadyReconciliated()
            const dateStr = formatDate(dateReported).replace('/', '-');
            const reportedDate = dateStr.replace('/', '-');

            var tmpData = data.find(r => r.DateReported === reportedDate.replace('/', '-') && r.VaultID === parseInt(vaultSelected.id));
            if (tmpData === undefined || tmpData === null) {
                setLoading(true)
                const balancesResponse = await getBNVaultBalances({ vaultId: vaultSelected.id });
                setLoading(false)

                let balances = []
                if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
                    balances = balancesResponse.result.filter(b => (Array.isArray(currencyDenominations) && currencyDenominations.some(c => c.CurrencyID === b.Currency)));
                    setVaultBalances(balances) // set balances in context for use in form and to avoid calling API again when needed                        
                } else {
                    setVaultBalances([]) // set empty to avoid issues in form if API call fails or returns no data
                }

                if (reconciliationId > 0) {
                    loadReconciliation({ VaultReconciliationID: reconciliationId })
                }
                else {

                    let newReconciliationItems = [];
                    defaultReconciliation.forEach(d => {
                        const currencyDetails = currencyDenominations.find(
                            (c) => c.CurrencyID === d.CurrencyID
                        );
                        if (currencyDetails && currencyDetails.Denominations) {
                            let item = { CurrencyID: currencyDetails.CurrencyID, ReportedValue: 0, ReconciliationDenominations: currencyDetails.Denominations };
                            newReconciliationItems.push(item);
                        }
                    });

                    newReconciliationItems.forEach(item => {

                        // helper to find matching balance entry
                        const findBalance = (currencyId, denomDesc) => {
                            if (!Array.isArray(balances)) return null;
                            return balances.find(b => b.Currency === currencyId && b['Denomination Description'] === denomDesc) || null;
                        }

                        item.ReconciliationDenominations.forEach(den => {
                            const balanceForItemCurrency = findBalance(item.CurrencyID, den.DenominationDescription);

                            den.InventoryNoNotes = balanceForItemCurrency ? balanceForItemCurrency['In Stock'] : 0
                            den.ReportedNoNotes = 0
                            den.InventoryValue = den.InventoryNoNotes
                            den.VbUpdateToken = balanceForItemCurrency ? balanceForItemCurrency['VbUpdateToken'] : ''
                        })
                        // kept: list of balances for this currency if needed elsewhere
                        const balanceForItemCurrency = balances.filter(b => b.Currency === item.CurrencyID)

                    })

                    console.log('newReconciliationItems', newReconciliationItems)

                    setPage("form");
                    setVaultReconciliationRecord({
                        VaultReconciliationID: 0,
                        VaultID: vaultSelected.id,
                        DateReported: dateReported,
                        ReportingUserID: localStorage.getItem("UserID"),
                        Status: "In Progress",
                        UpdateToken: "",
                        ReconciliationItems: newReconciliationItems,
                    });
                }
            } else {
                setAlertMessage({ ...alertMessage, show: true, title: 'Warning', message: `Already exists a reconciliation with same Date Reported and Vault.` })
            }
        };
    }

    const loadReconciliation = (record) => {
        loadVaultReconciliation(record.VaultReconciliationID);
        setPage("form");
    }

    const onBack = () => {
        setPage("list");
        loadVaultReconciliation(0);
        reload()
    } 

    const handleDeleteClick = (rec) => {        
        if(rec.Status !== 'Completed'){
            setConfirmationMessage({
                ...confirmationMessage, show: true, title: 'Confirm',
                message: `Please confirm if reconciliation for the date ${rec.DateReported} will be deleted.`,
                callback: deleteReconciliation,
                callbackParams: [rec.VaultReconciliationID, rec.UpdateToken]
            })
        } else {
            setAlertMessage({ ...alertMessage, show: true, title: 'Warning', message: `Completed reconciliation cannot be deleted.` })     
        }
    }

    const deleteReconciliation = async (vaultReconciliationId, updateToken) => {        

        setLoading(true)
        const response = await deleteVaultReconciliation(vaultReconciliationId, updateToken);
        setLoading(false)

        if (response && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Sucess', message: `Reconciliation deleted successfully` })            
            reload()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }
    
    switch (page) {
        case "form":
            return <ReconciliationBankNotesForm back={onBack} isBankNotesAdmin={isBankNotesAdmin} />;
        default:
            return (
                <>
                    <h3 className="uk-heading-divider" style={style.titleStyle}>
                        Reconciliation Bank Notes
                    </h3>
                    <div className="uk-grid">
                        <div className="uk-width-1-8">
                            <div className="uk-margin">
                                <label className="uk-form-label">Date Reported</label>
                                <div className="uk-form-controls">
                                    <DatePicker
                                        id={"dp-bos-fromdate"}
                                        key={"dp-bos-fromdate"}
                                        className="uk-input"
                                        style={style.inputStyle}
                                        value={dateReported}
                                        onDayChange={(date) => {
                                            const _date = formatDate(date);
                                            setDateReported(_date);
                                        }}
                                        endDate={new Date()} />
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-4">
                            <div className="uk-margin">
                                <label className="uk-form-label">Vaults</label>
                                <div className="uk-form-controls">
                                    <select
                                        id="vault-rc-sel-vault"
                                        className={formatValidSelect(validations.vault)}
                                        value={vaultSelected.id}
                                        onChange={(e) => {                                            
                                            setVaultSelected({
                                                name: e.target.selectedOptions[0].text,
                                                id: e.target.value,
                                            });
                                        }}
                                    >
                                        {vaultOptions.map((type) => (
                                            <option
                                                key={`status-option-${type.value}`}
                                                value={type.value}
                                            >{`${type.name}`}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-8 uk-margin">
                            <button
                                className="uk-button uk-button-green"
                                type="button"
                                onClick={() => {
                                    addNewReconciliation();
                                }}
                            >
                                Reconciliate
                            </button>
                        </div>
                    </div>
                    <hr />
                    <NewEditableGrid
                        id="grid-vault-reconciliation"
                        data={data}
                        columnDetails={columnDetails}
                        isEditable={false}
                        tableName={"vault-reconciliation"}
                        useExportButton={true}
                        enableClick={true}
                        clickFunction={(record) => {                            
                            loadReconciliation(record);
                        }}
                        useDeleteButton={isBankNotesAdmin}
                        deleteFunction={handleDeleteClick}
                        useIcons={true}
                    />
                </>
            );
    }
};

const ReconciliationBankNotesScreen = () => {
    return (
        <ReconciliationBankNotesProvider>
            <ReconciliationBankNotesScreenContent />
        </ReconciliationBankNotesProvider>
    );
};

export default ReconciliationBankNotesScreen;
